import { Routes } from '@angular/router';
import { loginRoutes } from '@softapps/allgemein/login';
import { settingsRoutes } from '@softapps/allgemein/utils';
import { passwordRoutes } from '@softapps/allgemein/password';
import { moduleRoutes } from '@softapps/allgemein/modules';
import { bestellvorschlagRoutes } from '@softapps/mde/bestellvorschlag';
import { bestellerfassungRoutes } from '@softapps/mde/bestellerfassung';
import { etikettendruckRoutes } from '@softapps/mde/etikettendruck';
import { mdeInventoryRoutes } from '@softapps/mde/inventory';
import { retourenRoutes } from '@softapps/mde/retouren';
import { artikelInfoRoutes } from '@softapps/wws/artikel-info';
import { artikelvorratRoutes } from '@softapps/mde/artikelvorrat';
import { materiallieferscheinScanRoutes } from '@softapps/mde/materiallieferschein-scan';
import { warenuebernahmeRoutes } from '@softapps/wws/warenuebernahme';
import { eslLinkRoutes } from '@softapps/handel/esl-link';
import { warenverprobungRoutes } from '@softapps/mde/warenverprobung';
import { orderRoutes } from '@softapps/werkstatt/order';

export const shellRoutes: Routes = [
  //Allgemein
  ...moduleRoutes,
  ...settingsRoutes,

  // MDE
  ...artikelvorratRoutes,
  ...artikelInfoRoutes,
  ...bestellerfassungRoutes,
  ...bestellvorschlagRoutes,
  ...etikettendruckRoutes,
  ...mdeInventoryRoutes,
  ...materiallieferscheinScanRoutes,
  ...retourenRoutes,
  ...warenverprobungRoutes,
  ...warenuebernahmeRoutes,
  ...eslLinkRoutes,

  // Werkstatt
  ...orderRoutes,
];

export const publicRoutes: Routes = [
  ...loginRoutes,
  ...passwordRoutes,
  ...settingsRoutes,
];

/*
export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('@softapps/core').then((o) => o.ShellComponent),
    children: [
      //Allgemein
      ...moduleRoutes,
      ...settingsRoutes,

      // MDE
      ...artikelvorratRoutes,
      ...artikelInfoRoutes,
      ...bestellerfassungRoutes,
      ...bestellvorschlagRoutes,
      ...etikettendruckRoutes,
      ...lagerInventurRoutes,
      ...materiallieferscheinScanRoutes,
      ...retourenRoutes,
      ...warenverprobungRoutes,
      ...warenuebernahmeRoutes,
      ...eslLinkRoutes,

      // Werkstatt
      ...auftragRoutes
    ],
    resolve: { settings: settingsResolver },
    canActivate: [AuthenticationGuard],
  },
  {
    path: '',
    loadComponent: () =>
      import('@softapps/core').then((o) => o.PublicShellComponent),
    children: [ ...loginRoutes, ...passwordRoutes, ...settingsRoutes],
  },
];*/
